import React from 'react';
import { connect } from 'react-redux';
import { AppState } from 'src/redux/reducers';
import { getWebOptions } from '../../../../options';
import CTAButton from '../../shared/CTAButton';
import Styles from './styles';
import { animateHorizontalIndicator } from '@utils/animations';

const WebMenu: React.FC<WebMenuReduxProps> = ({ user }) => {
  const filteredOptions = React.useMemo(() => {
    if (!user) {
      return [];
    }
    return getWebOptions(user).filter(option => option.enabled);
  }, [user]);

  React.useEffect(() => {
    const menu = document.getElementById('ggc__desktop-menu');
    const indicator = document.getElementById('desktop-menu-indicator');
    const menuItems = document.querySelectorAll(`#ggc__desktop-menu > div`);
    animateHorizontalIndicator({ container: menu, indicator, items: menuItems });
  }, []);
  return (
    <Styles.Container alignItems="center" justifyContent="space-between" gap="xmd" fullHeight id="ggc__desktop-menu">
      {filteredOptions.map(option => (
        <option.Component key={option.translationKey} option={option} />
      ))}
      {!user?.onboarded && <CTAButton />}
      <Styles.MenuIndicator id="desktop-menu-indicator" />
    </Styles.Container>
  );
};

const mapStateToProps = ({ userReducer }: AppState) => ({
  user: userReducer.user
});
export type WebMenuReduxProps = ReturnType<typeof mapStateToProps>;

export default connect(mapStateToProps)(WebMenu);
